import React from 'react';
import styles from './operation-panel-position.scss';

interface Props {
  children: React.ReactNode;
}

export const OperationPanelPosition: React.FunctionComponent<Props> = ({
  children,
}: Props) => <div className={styles.operationPanelPosition}>{children}</div>;
